/* Spejder Sport PDP — gift-card mode (card RFSjN9X7): Beløb denomination
 * pills (select a variant -> hidden variant-id input + ATC availability +
 * mobile sticky-bar price) and the Besked live character counter. Only
 * enqueued on gift-card products — sections/spejder-pdp.liquid gates the
 * <script> tag itself to gift-card mode (is_giftcard), so this never runs on the
 * standard PDP.
 */
(function () {
  function initAmountPills(root) {
    var wrap = root.querySelector('[data-giftcard-amount]');
    if (!wrap) return;
    var pills = wrap.querySelectorAll('[data-giftcard-pill]');
    if (!pills.length) return;

    var variantIdInput = root.querySelector('.product-variant-id');
    var addToCartBtn = root.querySelector('[data-add-to-cart]');
    var stickyPriceEl = root.querySelector('[data-pdp-sticky-bar] .spejder-pdp__sticky-price');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.classList.contains('is-selected')) return;

        pills.forEach(function (p) {
          p.classList.remove('is-selected');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');

        var variantId = pill.getAttribute('data-variant-id');
        var available = pill.getAttribute('data-available') === 'true';
        var price = pill.getAttribute('data-price');

        if (variantIdInput) variantIdInput.value = variantId;
        if (addToCartBtn) addToCartBtn.toggleAttribute('disabled', !available);
        if (stickyPriceEl && price) stickyPriceEl.textContent = price;
      });
    });
  }

  function initMessageCounter(root) {
    var textarea = root.querySelector('[data-giftcard-message]');
    var counterEl = root.querySelector('[data-giftcard-counter-current]');
    if (!textarea || !counterEl) return;
    var max = Number(textarea.getAttribute('maxlength')) || 60;

    function update() {
      var len = textarea.value.length;
      if (len > max) {
        textarea.value = textarea.value.slice(0, max);
        len = max;
      }
      counterEl.textContent = String(len);
    }

    textarea.addEventListener('input', update);
    update();
  }

  /* NaviPartner voucher JSON (snippets/spejder-pdp-giftcard-np.liquid, QA
   * card DltngWZu): the hidden properties[_JSON_DATA] input is seeded
   * server-side with the static keys; merge the designed form's recipient
   * name + message into it on every input so BC gets them at order import.
   * Keys mirror NP's spec (recipient_name / message); empty values are
   * dropped rather than sent as "". */
  function initNpJson(root) {
    var jsonInput = root.querySelector('[data-giftcard-np-json]');
    if (!jsonInput) return;
    var base;
    try {
      base = JSON.parse(jsonInput.value || '{}');
    } catch (e) {
      base = {};
    }
    var nameInput = root.querySelector('[data-giftcard-recipient-name]');
    var messageInput = root.querySelector('[data-giftcard-message]');

    function update() {
      var data = {};
      Object.keys(base).forEach(function (k) {
        data[k] = base[k];
      });
      var name = nameInput ? nameInput.value.trim() : '';
      var message = messageInput ? messageInput.value.trim() : '';
      if (name) data.recipient_name = name;
      if (message) data.message = message;
      jsonInput.value = JSON.stringify(data);
    }

    if (nameInput) nameInput.addEventListener('input', update);
    if (messageInput) messageInput.addEventListener('input', update);
    var form = jsonInput.closest('form');
    if (form) form.addEventListener('submit', update, true);
    update();
  }

  function init() {
    document.querySelectorAll('.spejder-pdp').forEach(function (root) {
      initAmountPills(root);
      initMessageCounter(root);
      initNpJson(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
